import React, { useCallback, useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import Loader from "components/Loader";
import styles from "./AddStaff.module.scss";
import ExpandableSearchBar from "accountOwner/pages/AddEvent/SchedulingAssistant/components/ExpandableSearchBar";
import Empty from "components/Empty";
function OfficeSelectionModal({
  t,
  isModalOpen,
  setIsModalOpen,
  selectedOffices,
  selectOfficeList,
  office_list: data,
  isOfficeLoading,
  selectedoffices,
}) {
  const [officeListSearch, setOfficeListSearch] = useState("");
  const [selectedVal, setSelectedVal] = useState(selectedOffices || []);
  const onSearch = (val) => {
    setOfficeListSearch(val);
  };
  const handleChange = useCallback((item, e) => {
    setSelectedVal((prev) => {
      if (e.target.checked) {
        return [...prev, item];
      }
      return prev.filter((v) => v.id !== item?.id);
    });
  }, []);
  const filterOffices = useMemo(() => {
    if (selectedoffices.length) {
      return selectedoffices.filter(
        (res) =>
          !selectedVal.length || !selectedVal.some((resp) => resp.id === res)
      );
    }
    return [];
  }, [selectedoffices]);
  
  const officeList = useMemo(() => {
    const trimSearch = officeListSearch.trim();
    if (data?.data.length) {
      return data?.data.filter((item) => {
        if (filterOffices.length && filterOffices.includes(item.id)) {
          return false;
        }
        if (trimSearch?.length) {
          return item.name.toLowerCase().includes(trimSearch.toLowerCase());
        }
        return true;
      });
    }
    return [];
  }, [officeListSearch, data?.data, filterOffices]);

  const handleAllChange = useCallback(
    (e) => {
      if (e.target.checked) {
        setSelectedVal(officeList);
      } else {
        setSelectedVal([]);
      }
    },
    [officeList]
  );
  const allSelected =
    selectedVal.length >= officeList.length &&
    officeList.every((res) => selectedVal.some((resp) => res.id === resp.id));
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className={"modal-dialog-centered modal-width-660"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => setIsModalOpen(false)}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">Select Office (s)</span>
          </Text>
          {isOfficeLoading && <Loader />}
          <div className={`search-box w-100 ${styles["search-box"]}`}>
            <ExpandableSearchBar
              placeholder={t("accountOwner.searchByName")}
              searchValue={officeListSearch}
              setSearchValue={onSearch}
              expanded={true}
            />
          </div>
          {officeList && officeList.length > 0 ? (
            <ul
              className={
                styles["change-list"] + " my-3 " + styles["modal-view-lists"]
              }
            >
              <li className={`ms-sm py-2 border-bottom`}>
                <div className={`ch-checkbox`}>
                  <label className="mr-5 mb-0">
                    <input
                      type="checkbox"
                      readOnly
                      onChange={handleAllChange}
                      checked={allSelected}
                      name="allSelected"
                    />
                    <span>Select All</span>
                  </label>
                </div>
              </li>
              {officeList.map((item, key, arr) => (
                <li
                  key={item.id}
                  className={`ms-sm my-2 ${
                    arr.length - 1 === key ? "" : "border-bottom"
                  }`}
                >
                  <div className="ch-checkbox">
                    <label className="mr-5">
                      <input
                        type="checkbox"
                        readOnly
                        onChange={handleChange.bind(this, item)}
                        checked={selectedVal.some(
                          (res) => item?.id === res?.id
                        )}
                        name="blockTimeslotAallDoctors"
                      />
                      <span>{item?.name} </span>
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <Empty Message="No office list available for your selection" />
          )}
          <button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            title={t("apply")}
            onClick={() => {
              selectOfficeList({
                officeIds: selectedVal,
              });
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
          >
            {t("apply")}
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link "
            onClick={() => {
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
            title={t("cancel")}
          >
            {t("cancel")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(OfficeSelectionModal);
